export default "__VITE_ASSET__DTw$3DlT__"